import { FC } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import EditorImg from 'lowcode/components/EditorImg';
import editorEventsBus from 'lowcode/utils/editorEventsBus';
import styled from './index.module.scss';
import { JpEcoCredits } from '@/components/MembersDay/FY2024/CommonElement/JpEcoCredits';
import { IProductItem } from '@/components/MembersDay/type';
// import { signupCookie } from '@/utils/cookies/signupCookie';
// import { useMembersStore } from '@/components/MembersDay/MembersProvider';
import gtm from '@/utils/gtm';
// import getLocal from '@/app/utils/getLocal';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';
interface IProps {
    title: string;
    data: IProductItem;
    entry_position?: number | string;
}

const SmallCard: FC<IProps> = ({ title, data, entry_position = 1 }) => {
    // const { isLogin } = useMembersStore();
    // const { locale } = getLocal();

    const handleDetail = () => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'bundle_add_to_cart',
            list_name: title,
            product_name: data.title,
            price: data.memberPrice,
            tag: 'none',
            quantity: 1,
            button_name: '今すぐ購入',
        });
        const { compareAtPrice, memberPrice, inventoryQuantity, title, variantId, productId, imageUrl } = data;
        EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
            {
                compareAtPrice: Number(compareAtPrice),
                price: Number(memberPrice),
                inventoryQuantity,
                inventoryPolicy: data?.inventoryPolicy || 'deny',
                productTitle: data?.productTitle || title,
                skuTitle: data?.skuTitle || title,
                variantId,
                productId,
                img: data?.img || imageUrl,
                variantImg: data?.variantImg || imageUrl,
                quantity: 1,
            } as ItfEcoCartItem,
        ]);
    };

    return (
        <div className={`${styled.SmallCard}`}>
            <div className="top">
                <EditorImg className="img" pc={data.imageUrl} />
                <p className="title">{data.title}</p>
                {data.discount && <div className="off">{data.discount} OFF</div>}
                <JpEcoCredits points={data.points} multiple={data.pointsMultiple} />
            </div>
            <div className="bottom">
                <p className="price">
                    大特価：
                    <span className="number">{data.memberPrice2}</span>
                    <span className="tax">(税込)</span>
                </p>
                <p className="compareat_price">通常価格：{data.compareAtPrice2}(税込)</p>
                <div className="tools">
                    <EditorLink
                        dataLayer={{
                            event: 'uaEvent',
                            event_name: 'buy',
                            product_name: data.title,
                            position: 'Member Day',
                        }}
                        className="btn learn_more"
                        href={data.productUrl}
                        target="_blank"
                    >
                        さらに詳しく
                    </EditorLink>
                    <EditorLink className="btn buy_now" onClick={handleDetail}>
                        今すぐ購入
                    </EditorLink>
                </div>
            </div>
        </div>
    );
};

export default SmallCard;
